import styled from 'styled-components';
import { CounterBadge } from 'ui/badge';
import { ErrorText as ErrorMessage } from 'ui/formField';
import { body2, body2Bold, fontSizes, fontWeights, spacing } from 'ui/theme';
import { pxToRem } from 'utils/convert';

export const StyledCounterBadge = styled(CounterBadge)`
  background-color: ${({ theme }) => theme.colors.primaryColors.red100};
`;

export const StyledButtons = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing.half};
`;

// button labels to be used with an icon
export const StyledLabel = styled.span`
  display: inline-block;
  margin-left: ${spacing.half};
`;

export const CampaignEditorBody = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-direction: row;
  gap: ${spacing.plusHalf};
  margin: ${spacing.double} 0;

  @media screen and (max-width: ${pxToRem(893)}) {
    flex-direction: column;
    align-items: center;
  }
`;

export const CampaignEditorContainer = styled.div`
  width: 100%;
  @media screen and (min-width: ${pxToRem(1681)}) {
    width: ${pxToRem(1842)};
    margin-left: auto;
    margin-right: auto;
  }
`;

export const StepperContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: ${spacing.double};
`;

export const ErrorText = styled(ErrorMessage)`
  margin-left: 0;
`;

export const OptionText = styled.span`
  ${body2};
`;

export const BoldText = styled.strong`
  all: unset;
  ${body2Bold};
  font-size: inherit; /** This will make sure BoldText will matches it's parent font-size. */
`;

/** TODO: this should be a core component */
export const Code = styled.code`
  font-family: 'Monaco', Consolas, 'Lucida Console', monospace;
  font-weight: ${fontWeights.regular};
  font-size: ${fontSizes.s12};
  color: ${({ theme }) => theme.colors.textColors.textSecondary};
  margin-left: auto;
`;

export const InfoBadge = styled.span`
  border: ${pxToRem(1)} solid #bdbdbd;
  border-radius: 5px;
  padding: 5px;
  font-size: 12px;
  color: ${({ theme }) => theme.colors.textColors.textPrimary};
`;

export const WarningBannerContainer = styled.div`
  margin-top: ${spacing.double};
`;
